import { create } from 'zustand';

export const useSloteDateStore = create((set) => ({
    selectedSlotDate: null,

    setDate: (date) => set({ selectedSlotDate: date }),

    clearDate: () => set({ selectedSlotDate: null }),
}));
